const fs = require('fs');
const path = require('path');

export default function handler(req, res) {
  try {
    const { path: filePath } = req.query;
    
    if (!filePath || !Array.isArray(filePath)) {
      return res.status(400).json({ error: 'Missing file path' });
    }

    // Use absolute path to be 100% sure on VPS
    const baseDir = '/www/wwwroot/projectbim';
    const safePath = path.join(baseDir, 'public', 'uploads', ...filePath);
    
    // Verify it exists
    if (!fs.existsSync(safePath)) {
      return res.status(404).send('Not Found');
    }

    // Security: Verify it's still inside the uploads directory
    const uploadsDir = path.join(baseDir, 'public', 'uploads');
    if (!safePath.startsWith(uploadsDir)) {
      return res.status(403).send('Forbidden');
    }

    const ext = path.extname(safePath).toLowerCase();
    const contentType = {
      '.png': 'image/png',
      '.jpg': 'image/jpeg',
      '.jpeg': 'image/jpeg',
      '.gif': 'image/gif',
      '.svg': 'image/svg+xml',
      '.webp': 'image/webp'
    }[ext] || 'application/octet-stream';

    res.setHeader('Content-Type', contentType);
    res.setHeader('Cache-Control', 'public, max-age=31536000, immutable');
    
    const stream = fs.createReadStream(safePath);
    stream.pipe(res);
  } catch (err) {
    console.error('API Error:', err);
    res.status(500).send('Internal Server Error');
  }
}
